export default __webpack_public_path__ + "static/media/location_light.26b0e43b.svg";